<template>
  <v-dialog v-model="leaveDialog" width="90%" @click:outside="closeLeaveDialog">
    <template v-slot:activator="{ on, attrs }">
      <p id="leaveDialog" v-bind="attrs" v-on="on" @click="openDialog"></p>
    </template>
    <v-card
      style="padding: 10px 20px 20px 20px; position: relative"
      class="text-center"
    >
      <v-row>
        <v-col md="12" style="padding: 0">
          <v-card-title>
            <v-spacer> </v-spacer>DAFTAR PENGAJUAN CUTI<v-spacer> </v-spacer>
            <v-btn
              small
              icon
              color="red"
              style="color: white; position: absolute; top: 5px; right: 5px"
              @click="closeDialog"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            mobile-breakpoint="0"
            fixed-header
            height="50vh"
            @click:row="openLeaveDetail"
            :headers="leaveHeaders"
            style="cursor: pointer"
            :items="filteredLeave"
            item-key="id"
            :footer-props="{
              showFirstLastPage: true,
              showCurrentPage: true,
              itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
            }"
          >
            <template v-slot:[`item.employee`]="{ item }">
              <div
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ item.employee != null ? item.employee.name : '-' }}
              </div>
            </template>
            <template v-slot:[`item.company`]="{ item }">
              <div
                v-if="item.company !== null"
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ item.company.name }}
              </div>
            </template>
            <template v-slot:[`item.department`]="{ item }">
              <div
                v-if="item.department !== null"
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ item.department.name }}
              </div>
            </template>
            <template v-slot:[`item.status_leave`]="{ item }">
              <div
                :style="`text-transform:uppercase; font-size:14px; padding: 0; display: flex; flex-direction: row; color:${statusColor(
                  item.status_leave
                )};`"
              >
                {{ requestStatus(item.status_leave) }}
              </div>
            </template>
            <template v-slot:[`item.leave_type`]="{ item }">
              <div
                style="
                  font-size: 12px;
                  padding: 0;
                  display: flex;
                  flex-direction: row;
                "
              >
                {{ item.leave_type != null ? item.leave_type.name : '-' }}
              </div>
            </template>
            <template v-slot:[`item.request_leave_date`]="{ item }">
              <div
                @click.stop
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <div class="leave-date-col">
                  <div style="display: flex; flex-direction: row">
                    <v-chip
                      small
                      label
                      v-for="(items, index) in item.request_leave_date"
                      :key="index"
                      style="
                        margin: 0 5px 0 5px;
                        font-size: 10px;
                        margin-bottom: 3px;
                      "
                    >
                      {{
                        items.start_date.split('-').reverse().join('-') +
                        ' s/d ' +
                        items.end_date.split('-').reverse().join('-')
                      }}
                    </v-chip>
                  </div>
                </div>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LeaveDialog',
  props: ['filteredLeave'],
  data() {
    return {
      leaveDialog: false,
      isLoading: false
    }
  },
  computed: {
    leaveHeaders() {
      return [
        {
          text: 'No. Pengajuan',
          value: 'request_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama',
          value: 'employee',
          align: 'left',
          sortable: false
        },
        {
          text: 'Perusahaan',
          value: 'company',
          align: 'left',
          sortable: false
        },
        {
          text: 'Department/ Section',
          value: 'department',
          align: 'left',
          sortable: false
        },
        {
          text: 'Jenis Cuti',
          value: 'leave_type',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Cuti',
          value: 'request_leave_date',
          align: 'left',
          sortable: false
        },
        {
          text: 'Hari',
          value: 'total_requested_leave',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status_leave',
          align: 'left',
          sortable: false
        }
      ]
    }
  },
  methods: {
    openDialog() {
      console.log(this.filteredLeave)
    },
    closeDialog() {
      this.leaveDialog = false
    },
    convertDateTime(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    convertDate2(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = Intl.DateTimeFormat('id', {
          day: 'numeric',
          month: 'long'
        }).format(date)
        return local
      }
    },
    closeLeaveDialog() {
      this.leaveDialog = false
    },
    openLeaveDetail(item) {
      setTimeout(() => {
        window.open(`/hr/leave/detail/${item.id}`, '_blank')
      }, 100)
    },
    statusColor(val) {
      switch (val) {
        case -2:
          return 'red'
        case -1:
          return 'red'
        case 0:
          return 'blue'
        case 1:
          return 'orange'
        case 2:
          return 'orange'
        case 3:
          return 'green'
        default:
          break
      }
    },
    requestStatus(val) {
      switch (val) {
        case -2:
          return 'CANCELED'
        case -1:
          return 'REJECTED'
        case 0:
          return 'DRAFT'
        case 1:
          return 'WAITING APPROVAL'
        case 2:
          return 'WAITING APPROVAL'
        case 3:
          return 'APPROVED'
        default:
          return ''
      }
    }
  }
}
</script>

<style></style>
